module.exports = __webpack_public_path__ + "static/img/05.a3897b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/05.png
// module id = ACq9
// module chunks = 1